import React from 'react';
import './App.css';

function SupportPage() {
  return (
    <>
      {/* Hero Section */}
      <section className="hero-modern">
        <div className="hero-background"></div>
        <div className="container">
          <div className="hero-content">
            <div className="hero-text">
              <div className="app-logo">
                <div className="logo-icon">
                  <svg width="48" height="48" viewBox="0 0 48 48" fill="none">
                    <rect width="48" height="48" rx="12" fill="url(#gradient1)"/>
                    <path d="M12 20h24v8H12v-8z" fill="white" opacity="0.9"/>
                    <circle cx="16" cy="24" r="2" fill="white"/>
                    <circle cx="32" cy="24" r="2" fill="white"/>
                    <defs>
                      <linearGradient id="gradient1" x1="0" y1="0" x2="48" y2="48">
                        <stop stopColor="#6366F1"/>
                        <stop offset="1" stopColor="#4C1D95"/>
                      </linearGradient>
                    </defs>
                  </svg>
                </div>
                <div className="logo-text">
                  <h1>Where2Exit</h1>
                  <span>R1 Light Rail Exit Finder</span>
                </div>
              </div>
              <h2>Smart Navigation for Israel's Light Rail</h2>
              <p>Never miss your stop again. Get personalized exit recommendations that save you time and make your journey effortless.</p>
              <div className="hero-badges">
                <div className="badge-modern">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 2L13 8h5l-4 4 1.5 6L10 15l-5.5 3L6 12l-4-4h5l3-6z" fill="currentColor"/>
                  </svg>
                  Available on iOS
                </div>
                <div className="badge-modern secondary">
                  <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                    <path d="M10 18a8 8 0 100-16 8 8 0 000 16zM9 9V7a1 1 0 112 0v2a1 1 0 11-2 0zm1 4a1 1 0 100-2 1 1 0 000 2z" fill="currentColor"/>
                  </svg>
                  Free to Use
                </div>
              </div>
            </div>
            <div className="hero-visual">
              <div className="phone-mockup">
                <div className="phone-screen">
                  <div className="app-preview">
                    <div className="preview-header"></div>
                    <div className="preview-map"></div>
                    <div className="preview-card"></div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Features Section */}
      <section className="features-modern">
        <div className="container">
          <div className="section-header">
            <h3>Why Choose Where2Exit?</h3>
            <p>Powerful features designed to enhance your light rail experience</p>
          </div>
          <div className="features-grid-modern">
            <div className="feature-card">
              <div className="feature-icon-modern">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <circle cx="16" cy="16" r="14" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 8v8l4 4" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h4>Smart Recommendations</h4>
              <p>AI-powered exit suggestions based on your destination, saving you valuable walking time.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-modern accessibility">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M16 4a4 4 0 100 8 4 4 0 000-8zM12 14a2 2 0 00-2 2v8a2 2 0 104 0v-6h4v6a2 2 0 104 0v-8a2 2 0 00-2-2h-8z" fill="currentColor"/>
                </svg>
              </div>
              <h4>Accessibility First</h4>
              <p>Find wheelchair-accessible routes with elevator locations and barrier-free paths.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-modern">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M4 8a4 4 0 018 0v16a4 4 0 01-8 0V8zM20 8a4 4 0 018 0v16a4 4 0 01-8 0V8z" fill="currentColor"/>
                </svg>
              </div>
              <h4>Bilingual Support</h4>
              <p>Seamless Hebrew and English interface for all users across Israel.</p>
            </div>
            <div className="feature-card">
              <div className="feature-icon-modern">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <path d="M28 16c0 6.627-5.373 12-12 12S4 22.627 4 16 9.373 4 16 4s12 5.373 12 12z" stroke="currentColor" strokeWidth="2"/>
                  <path d="M16 8v8h8" stroke="currentColor" strokeWidth="2" strokeLinecap="round"/>
                </svg>
              </div>
              <h4>Real-time Updates</h4>
              <p>Live station information and walking directions updated in real-time.</p>
            </div>
          </div>
        </div>
      </section>

      {/* FAQ Section */}
      <section className="faq-modern">
        <div className="container">
          <div className="section-header">
            <h3>Frequently Asked Questions</h3>
            <p>Everything you need to know about using Where2Exit</p>
          </div>
          <div className="faq-grid">
            <div className="faq-card">
              <div className="faq-question">
                <h4>Which stations does the app cover?</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>Where2Exit covers all 34 stations on the R1 Red Line from Petach Tikva Central to Bat Yam HaKomemiyut, including both underground and surface stations across 6 cities.</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>How does the app determine the best exit?</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>Our algorithm calculates the shortest walking distance from each station exit to your destination, considering accessibility needs and nearby landmarks to recommend the most convenient option.</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>Can I use the app without location services?</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>Absolutely! You can manually search for destinations, browse stations on the map, or select locations without enabling location services. Location access just provides more personalized recommendations.</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>Does the app work offline?</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>Core station and exit information is available offline. Interactive maps and destination search require an internet connection for the best experience.</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>Is the app free to use?</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>Yes! Where2Exit is completely free to download and use. No subscriptions, no in-app purchases, no ads.</p>
              </div>
            </div>
            <div className="faq-card">
              <div className="faq-question">
                <h4>How accurate are the walking times?</h4>
                <div className="faq-icon">+</div>
              </div>
              <div className="faq-answer">
                <p>Walking times are calculated based on average walking speeds and real distances. Times may vary based on individual pace, crowds, and accessibility needs.</p>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Contact Section */}
      <section className="contact-modern">
        <div className="container">
          <div className="contact-wrapper">
            <div className="contact-content">
              <div className="section-header">
                <h3>Need Help?</h3>
                <p>We're here to ensure your light rail experience is smooth and effortless</p>
              </div>
              <div className="contact-grid">
                <div className="contact-card">
                  <div className="contact-icon">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M3 8l7.89 5.26a2 2 0 002.22 0L21 8M5 19h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v10a2 2 0 002 2z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h4>Technical Support</h4>
                  <p>Having issues with the app? We're here to help you get back on track.</p>
                  <a href="mailto:support@where2exit.app" className="contact-link-modern">
                    support@where2exit.app
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8h10m0 0l-3-3m3 3l-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                </div>
                <div className="contact-card">
                  <div className="contact-icon feedback">
                    <svg width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <path d="M9 12l2 2 4-4m6 2a9 9 0 11-18 0 9 9 0 0118 0z" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </div>
                  <h4>Feature Requests</h4>
                  <p>Have ideas to make Where2Exit even better? We'd love to hear them!</p>
                  <a href="mailto:feedback@where2exit.app" className="contact-link-modern">
                    feedback@where2exit.app
                    <svg width="16" height="16" viewBox="0 0 16 16" fill="none">
                      <path d="M3 8h10m0 0l-3-3m3 3l-3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round" strokeLinejoin="round"/>
                    </svg>
                  </a>
                </div>
              </div>
              <div className="response-time">
                <svg width="20" height="20" viewBox="0 0 20 20" fill="none">
                  <circle cx="10" cy="10" r="8" stroke="currentColor" strokeWidth="1.5"/>
                  <path d="M10 6v4l3 3" stroke="currentColor" strokeWidth="1.5" strokeLinecap="round"/>
                </svg>
                <span>We typically respond within 24 hours</span>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer className="footer-modern">
        <div className="container">
          <div className="footer-content-modern">
            <div className="footer-brand">
              <div className="footer-logo">
                <svg width="32" height="32" viewBox="0 0 32 32" fill="none">
                  <rect width="32" height="32" rx="8" fill="url(#footerGradient)"/>
                  <path d="M8 13h16v6H8v-6z" fill="white" opacity="0.9"/>
                  <circle cx="11" cy="16" r="1.5" fill="white"/>
                  <circle cx="21" cy="16" r="1.5" fill="white"/>
                  <defs>
                    <linearGradient id="footerGradient" x1="0" y1="0" x2="32" y2="32">
                      <stop stopColor="#6366F1"/>
                      <stop offset="1" stopColor="#4C1D95"/>
                    </linearGradient>
                  </defs>
                </svg>
                <span>Where2Exit</span>
              </div>
              <p>Making light rail travel effortless across Israel</p>
            </div>
            <div className="footer-stats">
              <div className="stat">
                <strong>34</strong>
                <span>Stations</span>
              </div>
              <div className="stat">
                <strong>6</strong>
                <span>Cities</span>
              </div>
              <div className="stat">
                <strong>65+</strong>
                <span>Exits</span>
              </div>
            </div>
          </div>
          <div className="footer-bottom-modern">
            <p>&copy; 2025 Where2Exit. Designed with ❤️ for Israeli commuters.</p>
            <div className="footer-version">
              <span>Version 1.0 • iOS 17.6+</span>
            </div>
          </div>
        </div>
      </footer>
    </>
  );
}

export default SupportPage;